"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var GridFilterConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(GridFilterConverter, _DataObjectConverter_);

  function GridFilterConverter() {
    _classCallCheck(this, GridFilterConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(GridFilterConverter).apply(this, arguments));
  }

  return GridFilterConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.GridFilterConverter = GridFilterConverter;